module.exports = __webpack_public_path__ + "media/images/niq-excel-b4753908971a86742ee5e5b8618f9744.svg";